import client from './../../utils/http-client'
import {injectable} from "inversify";

export class HomeService {
    constructor() {
        this.client = client;
    }

    async getWorksPage() {
        const postReponse = await client.get(`pages/1778`);
        if(postReponse.status !== 200) {
            return false;
        }
        return postReponse.data;
    }

    async getHeader() {
        const postReponse = await client.get(`pages/1798`);
        if(postReponse.status !== 200) {
            return false;
        }
        return postReponse.data;
    }

    async getServices() {
        const postReponse = await client.get(`pages/1822`);
        if(postReponse.status !== 200) {
            return false;
        }
        return postReponse.data;
    }

    async getInfluencers() {
        const postReponse = await client.get(`pages/1833`);
        if(postReponse.status !== 200) {
            return false;
        }
        return postReponse.data;
    }

    async getBrands() {
        const brandsResponse = await client.get(`pages/1849`);
        if(brandsResponse.status !== 200) {
            return false;
        }
        return brandsResponse.data;
    }
}
injectable()(HomeService);
